import { useRef } from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { FiCalendar } from "react-icons/fi";
import { LOCALES } from "../constants/locales";

interface InputDatePickerProps {
    label: string | undefined;
    value: Date | null | undefined;
    onChange?: (value: Date | null) => void;
    disabled?: boolean;
    hasError?: boolean;
    errorMessage?: string;
}

export function InputDatePicker({ label, value, onChange, disabled, hasError = false, errorMessage }: InputDatePickerProps) {
    const datepickerRef = useRef<any>(null);
    const { i18n } = useTranslation();
    const openCalendar = () => {
        if (datepickerRef.current) {
            datepickerRef.current.setFocus();
        }
    };
    const language = (i18n.resolvedLanguage ?? "es").split("-")[0];

    return (
        <div className="w-100">
            <label className="form-label">{label}</label>
            <div className="input-calendar">
                <DatePicker
                    locale={LOCALES[language] ?? LOCALES.ca}
                    ref={datepickerRef}
                    selected={value}
                    onChange={onChange}
                    dateFormat="dd/MM/yyyy"
                    className={`form-control ${hasError ? "is-invalid" : ""}`}
                    portalId="root-portal-datepicker"
                    wrapperClassName="w-100"
                    disabled={disabled}
                />
                <span className="content-icon-calendar"
                    onClick={openCalendar}
                    style={{ cursor: "pointer" }}
                >
                    <FiCalendar className="icon-calendar" />
                </span>
            </div>
            {hasError && (
                <div className="invalid-feedback d-block">
                    {errorMessage}
                </div>
            )}
        </div>
    );
}

